import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { STEP_ORDER, type FAN_STYLE_OPTIONS } from '../constants/fanStyle';
import type { FanStyle } from '../FanBuddySettingPage';

interface UseHandleFanStyleStepProps {
  onUpdateFanStyle: (fanStyle: Partial<FanStyle>) => void;
  onComplete: () => void;
  initialStep?: keyof typeof FAN_STYLE_OPTIONS;
}

export const useHandleFanStyleStep = ({
  onUpdateFanStyle,
  onComplete,
  initialStep
}: UseHandleFanStyleStepProps) => {
  const [currentStep, setCurrentStep] = useState<keyof typeof FAN_STYLE_OPTIONS>(
    initialStep ?? 'fanCareerLevel'
  );

  const navigate = useNavigate();

  const getNextStep = (
    current: keyof typeof FAN_STYLE_OPTIONS
  ): keyof typeof FAN_STYLE_OPTIONS | null => {
    const currentIndex = STEP_ORDER.indexOf(current);
    if (currentIndex < STEP_ORDER.length - 1) {
      return STEP_ORDER[currentIndex + 1];
    }
    return null;
  };

  const getPreviousStep = (
    current: keyof typeof FAN_STYLE_OPTIONS
  ): keyof typeof FAN_STYLE_OPTIONS | null => {
    const currentIndex = STEP_ORDER.indexOf(current);
    if (currentIndex > 0) {
      return STEP_ORDER[currentIndex - 1];
    }
    return null;
  };

  const handleOptionClick = (optionId: string) => {
    onUpdateFanStyle({ [currentStep]: optionId });
    const nextStep = getNextStep(currentStep);
    if (nextStep) {
      setCurrentStep(nextStep);
    } else {
      onComplete();
    }
  };

  const handlePreviousStep = () => {
    onUpdateFanStyle({ [currentStep]: '' });
    const previousStep = getPreviousStep(currentStep);
    if (previousStep) {
      setCurrentStep(previousStep);
    } else {
      navigate('/fan-buddy/intro');
    }
  };

  return {
    currentStep,
    handleOptionClick,
    handlePreviousStep
  };
};
